import { z } from 'zod';

import type { Corner } from '../../utils';
import { CORNERS, responsiveSchema } from '../../utils';

/** Four corners and one unit — a border radius. */
export const cornersSchema = z.object({
    value: z.object({
        topLeft: z.coerce.number().default(0),
        topRight: z.coerce.number().default(0),
        bottomRight: z.coerce.number().default(0),
        bottomLeft: z.coerce.number().default(0),
    }),
    unit: z.enum(['px', '%']).default('px'),
});

export const responsiveCornersSchema = responsiveSchema(cornersSchema);

export type Corners = z.output<typeof cornersSchema>;
export type CornerValues = Corners['value'];

/** Every corner the same, `0px` by default. */
export const createCorners = (value = 0, unit: Corners['unit'] = 'px'): Corners => ({
    value: Object.fromEntries(CORNERS.map((corner: Corner) => [corner, value])) as CornerValues,
    unit,
});
